{
  "name": "angular-project-model",
  "version": "0.0.18-rc.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:local": "ng build --configuration=local",
    "build:dev": "ng build --configuration=dev",
    "build:rec": "ng build --configuration=rec",
    "build:prd": "ng build --configuration=prd",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.1.3",
    "@angular/common": "^20.1.3",
    "@angular/compiler": "^20.1.3",
    "@angular/core": "^20.1.3",
    "@angular/forms": "^20.1.3",
    "@angular/platform-browser": "^20.1.3",
    "@angular/platform-browser-dynamic": "^20.1.3",
    "@angular/router": "^20.1.3",
    "@ng-bootstrap/ng-bootstrap": "^19.0.0",
    "@popperjs/core": "^2.11.6",
    "ag-grid-angular": "^32.0.1",
    "ag-grid-community": "^32.0.1",
    "angular-oauth2-oidc": "^13.0.1",
    "angular-oauth2-oidc-jwks": "^13.0.1",
    "bootstrap": "^5.3.7",
    "bootstrap-icons": "^1.13.1",
    "dayjs": "^1.11.5",
    "jwt-decode": "^3.1.2",
    "ngx-toastr": "^15.2.2",
    "rxjs": "~7.5.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^19.8.0",
    "@angular-eslint/eslint-plugin": "19.8.0",
    "@angular-eslint/eslint-plugin-template": "19.8.0",
    "@angular-eslint/schematics": "19.8.0",
    "@angular-eslint/template-parser": "19.8.0",
    "@angular/build": "^20.1.3",
    "@angular/cli": "^20.1.3",
    "@angular/compiler-cli": "^20.1.3",
    "@angular/localize": "^20.1.3",
    "@types/jasmine": "~4.0.0",
    "@typescript-eslint/eslint-plugin": "5.62.0",
    "@typescript-eslint/parser": "5.62.0",
    "eslint": "^8.51.0",
    "jasmine-core": "~4.3.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "prettier": "^2.7.1",
    "typescript": "^5.8.3"
  }
}
